import z from 'zod';
import { WebsiteUserRoleBitMaskEnum } from '../user/base.js';
export var EducationCategoryEnum;
(function (EducationCategoryEnum) {
    EducationCategoryEnum["ARTICLES"] = "Articles";
    EducationCategoryEnum["CALCULATORS"] = "Calculators";
    EducationCategoryEnum["CALL_RECORDINGS"] = "Call Recordings";
    EducationCategoryEnum["COURSES"] = "Courses";
    EducationCategoryEnum["GUIDES"] = "Guides";
    EducationCategoryEnum["PODCASTS"] = "Podcasts";
    EducationCategoryEnum["TEMPLATES"] = "Templates";
    EducationCategoryEnum["VIDEOS"] = "Videos";
})(EducationCategoryEnum || (EducationCategoryEnum = {}));
export const educationSchema = z.object({
    id: z.string(),
    title: z.string(),
    author: z.string(),
    bit_mask: z.enum(WebsiteUserRoleBitMaskEnum),
    thumbnail: z.url(),
    length: z.number().positive(),
    category: z.enum(EducationCategoryEnum).optional(),
    permalink: z.string(),
});
